







































import { defineComponent, watch, ref } from "@vue/composition-api"

export default defineComponent({

  name : "Description",

  props:{
    description:{
      type:String,
      default:""
    }
  },

  setup(props) {

    var readMoreActivated = ref(false)

    watch(() => props.description, (newValue:any) => {
      if (props.description && props.description.length > 500 ) {
        readMoreActivated.value = false
      }else{
        readMoreActivated.value = true
      }
    });

    return{
      readMoreActivated
    }

  }
});
